<template>
<div>
  <div class="form-group">
  <label>Start Date</label>
  <input type="date" class="btn btn-sm btn-default" placeholder="YYYY-MM-DD" name="report_start_date" v-model="formData.reportStartDate"/>
  </div>
  <div class="form-group">
  <label>End Date</label>
  <input type="date" class="btn btn-sm btn-default" placeholder="YYYY-MM-DD" name="report_end_date" v-model="formData.reportEndDate"/>
  </div>
  <button type="button" @click="onClick($event)">Run Report</button>
  <label>{{ statusMessage }}</label>
  <confirm-modal :show-confirm="showConfirm" confirm-message="Do you want to create this report?" @ok="confirmReport" @cancel="cancelReport"></confirm-modal>
  <br/><br/>

</div>
</template>

<script>
import axios from "axios";
import ConfirmModal from "../ConfirmModal";
export default {
  name: "EmdFields",
  components: {ConfirmModal},
  props: {
    emdId : {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formData: {
        emdId : this.emdId,
        reportStartDate: '',
        reportEndDate: ''
      },
      showConfirm: false,
      statusMessage: '',
      showStatusMessage: false,
      validated: false,
    }
  },
  methods: {
    onClick: function (event){
      event.preventDefault()
      this.validated = this.validateForm();
      if(this.validated) {
        this.showConfirm = true
      }
     this.timer()
    },
    run: function () {
        axios.post('runcrm', this.formData)
            .then(response => {
              this.statusMessage = response.data.statusMessage
              if(response.data.status === 'success') {
                this.$emit('success');
              }
              if(response.data.status === 'error') {
                this.showErrors(response.data.errors)
              }
              return Promise.resolve()
            })
    },
    validateForm: function () {
      if(this.formData.reportStartDate === "" || this.formData.reportEndDate === "") {
        this.statusMessage = "You must enter both dates to create a report."
        this.showStatusMessage = true
        return false
      }
      if(this.formData.reportStartDate >= this.formData.reportEndDate) {
        this.statusMessage = "The report Start Date has to be before the report End Date."
        this.showStatusMessage = true
        return false
      }
      return true
    },
    confirmReport: function () {
      this.showConfirm = false
      this.statusMessage = "Your report is being generated."
      this.showStatusMessage = true
      this.run()
      this.timer()
    },
    cancelReport: function () {
      this.showConfirm = false
      this.statusMessage = "The report has been cancelled."
      this.showStatusMessage = true
      this.timer()
    },
    timer() {
      setTimeout(() => {
        this.showStatusMessage = false
        this.statusMessage = ''
      }, 5000)
    },
    showErrors(errors) {
      let message = ""
      Object.values(errors).forEach( val => message += val[0])
      this.statusMessage = message
      this.showStatusMessage = true
    }
  }
}
</script>